import config from './config'
import api from './api'

const LoggerServices = {
  createLog: async (data, options) => {
    const res = await api.request({
      method: config.endpoints.log.v2.method,
      path: config.endpoints.log.v2.path,
      host: config.endpoints.log.v2.host,
      data,
      options,
    })
    return res
  }
}
export default LoggerServices
